import { render, staticRenderFns } from "./product-excess-form.vue?vue&type=template&id=1faa30a4&scoped=true&"
import script from "./product-excess-form.vue?vue&type=script&lang=js&"
export * from "./product-excess-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faa30a4",
  null
  
)

export default component.exports